import { BaseApiService } from '@/shared/api/services/base.service';

export interface OnboardingSlideAttributes {
  index: number;
  title: string;
  description: string;
  overlay_text: string | null;
  image_url: string;
}

export interface OnboardingSlide {
  type: 'onboarding-slide';
  id: string;
  attributes: OnboardingSlideAttributes;
}

interface OnboardingSlidesResponse {
  data: OnboardingSlide[];
}

class OnboardingService extends BaseApiService {
  async getSlides(): Promise<OnboardingSlide[]> {
    const response = await this.httpGet<OnboardingSlidesResponse>(
      '/v1/onboarding/slides'
    );
    return response.data;
  }
}

export const onboardingService = new OnboardingService();
